import subsComponent from "./vue_components/subs_component.vue.js";

export default [
    {
        path: '/',
        redirect: '/login/'
    },
    {
        path: "/email/",
        component: subsComponent,
        props: {
            current: 'email'
        }
    },
    {
        path: "/fullName/",
        component: subsComponent,
        props: {
            current: 'fullName'
        }
    },
    {
        path: "/username/",
        component: subsComponent,
        props: {
            current: 'username'
        }
    },
    {
        path: "/password/",
        component: subsComponent,
        props: {
            current: 'password'
        }
    },
    {
        path: "/signin/",
        component: subsComponent,
        props: {
            current: 'signin'
        }
    },
    {
        path: "/forgot/",
        component: subsComponent,
        props: {
            current: 'forgot'
        }
    },
    {
        path: "/reset/",
        component: subsComponent,
        props: {
            current: 'reset'
        }
    },
    {
        path: "/reset_password/",
        component: subsComponent,
        props: {
            current: 'reset_password'
        }
    },
    {
        path: "/zipcode/",
        component: subsComponent,
        props: {
            current: 'zipcode'
        }
    },
    {
        path: "/welcome/",
        component: subsComponent,
        props: {
            current: 'welcome'
        }
    },
    {
        path: "/video/",
        component: subsComponent,
        props: {
            current: 'video'
        }
    },
    {
        path: '/register/',
        component: subsComponent,
        props: {
            current: 'register'
        }
    },
    {
        path: '/login/',
        component: subsComponent,
        props: {
            current: 'login'
        }
    },
];
